var render = function render(){
  var _vm$employer, _vm$employer$intervie, _vm$employer2, _vm$employer2$intervi;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !((_vm$employer = _vm.employer) !== null && _vm$employer !== void 0 && (_vm$employer$intervie = _vm$employer.interview) !== null && _vm$employer$intervie !== void 0 && _vm$employer$intervie.isOnline) ? _c('v-card', {
    staticClass: "d-flex align-center justify-center py-16 px-24",
    attrs: {
      "flat": "",
      "color": "grey-f1",
      "rounded": "lg"
    }
  }, [_c('p', {
    staticClass: "page--text text-center primary--text"
  }, [_c('span', [_vm._v(" 면접장소: " + _vm._s((_vm$employer2 = _vm.employer) === null || _vm$employer2 === void 0 ? void 0 : (_vm$employer2$intervi = _vm$employer2.interview) === null || _vm$employer2$intervi === void 0 ? void 0 : _vm$employer2$intervi.location) + " ")])]), _c('expo-employer-map', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-10 my-n6",
          attrs: {
            "small": "",
            "height": "28",
            "color": "kakao"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "ml-n2",
          attrs: {
            "size": "20",
            "color": "kakao-marker"
          }
        }, [_vm._v("mdi-map-marker")]), _c('span', [_vm._v(" 카카오맵 확인 ")])], 1)];
      }
    }], null, false, 197847546)
  }, 'expo-employer-map', {
    employer: _vm.employer
  }, false))], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }